import React from "react";
import styles from "../centromedicodonavitta_/missao_centromedicodonavitta_.module.scss";
import { ArrowLeft } from "lucide-react";
import WhatsappIcon from "../../icons/whatsappIcon.tsx";
import MapsIcon from "../../icons/mapsIcon.tsx";
import InstagramIcon from "../../icons/instagramIcon.tsx";
import { Link } from "react-router-dom";

const Missao_centromedicodonavitta_: React.FC = () => {
    return (
        <div className={styles.missao_centromedicodonavitta_}>
            {/* Header */}
            <div className={styles.header}>
                <Link to="/centromedicodonavitta_" className={styles.backButton}>
                    <ArrowLeft />
                </Link>
                <h1>Missão e Propósito</h1>
            </div>

            {/* Conteúdo */}
            <div className={styles.content}>
                <div className={styles.block}>
                    <h2>Missão</h2>
                    <p>
                        Cuidar da saúde da mulher em todas as fases da vida: da primeira
                        menstruação à menopausa.
                    </p>
                </div>

                <div className={styles.block}>
                    <h2>Propósito</h2>
                    <p>
                        Entregar acolhimento, excelência e cuidado, fortalecendo a autonomia e o
                        protagonismo da mulher.
                    </p>
                </div>
            </div>

            {/* Footer */}
            <div className={styles.footer}>
                <p className={styles.footerTitle}>
                    Dona Vitta • Centro Médico da Mulher
                </p>
                <p className={styles.footerSubtitle}>
                    Seja Dona • Seja Vitta
                </p>

                <div className={styles.footerLinks}>
                    <a
                        href="https://www.instagram.com/centromedicodonavitta_?igsh=Y2t6Z2hseWVpZDQ1"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <InstagramIcon color="#456345" height="28" />
                    </a>
                    <a
                        href="https://maps.app.goo.gl/i5ygw1tv3QZEUeq88"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <MapsIcon color="#456345" height="36" />
                    </a>
                </div>
            </div>

            {/* Botão WhatsApp flutuante */}
            <a
                href="https://wa.me/5517981360002?text=Olá! Vim pelo seu cartão digital e gostaria de agendar uma consulta na Dona Vitta"
                className={styles.whatsappFloat}
                target="_blank"
                rel="noopener noreferrer"
            >
                <WhatsappIcon color="#fff" />
            </a>
        </div>
    );
};

export default Missao_centromedicodonavitta_;
